







































































































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import mytable from '../table/my-table.vue'
import charts from '../charts/index.vue'

@Component({
    components: {charts,mytable}
})
export default class extends AbpBase {
    @Prop({type: String, default: '80%'}) width: String;
    @Prop({type: Boolean, default: false}) value: Boolean;
    @Prop({type: Object, default: {}}) data: any;

    //表格高度
    get dialogHeight(){
        return (window.innerHeight-280)
    }

    cancel(){
        this.$emit('input', false);
    }
    //tabs切换方法
    activeNameChange(val:any){
        if(this.activeName!='0'){
            if(this.activeName != this.result.name){
                let active = this.subTabData.find((e:any)=>{return e.name == this.activeName})
                this.load(
                    this.subqueryParaIdArr,
                    active.drillQueryTypeId,
                    active.id,
                    active.queryResultArr,
                    this.sublist,
                )
            }
        }
    }
    searchPopShow = false
    tabs:any = [
    ]
    form:any = {
        name:name
    }
    activeName = ''
    removeTab(targetName){
        let ri;
        this.tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
                let nextTab = this.tabs[index + 1] || this.tabs[index - 1];
                if (nextTab) {
                    this.activeName = nextTab.name;
                }
                ri = index
            }
        });
        this.tabs.splice(ri,1)
        this.subTabData.splice(ri-1,1)
    }
    //根级数据存储
    columns:any = []
    result:any = {}
    list:any = []
    //钻取数据动态存储
    subcolumns:any = []
    subresult:any = {}
    sublist:any = []
    created(){
        console.log(this.data)
        this.load(
            this.data.queryParaIdArr,
            this.data.drillQueryTypeId,
            this.data.id,
            this.data.queryResultArr,
            this.list,
            true
        )
    }
    //需要钻取的表格加上详情列
    renderRow(result){
        let row = result.queryResultDto.map((v,index) => {
            return {
                title:v.columnComment,
                key:'k'+index
            }
        });
        //是否钻取
        if(!!result.drillQueryTypeId){
            row.push({
                title:'操作',
                width:60,
                render:(h:any,p:any)=>{
                    return h('el-button',{
                        props:{
                            type:'text',
                            size:'small',
                        },
                        on:{
                            click:()=>{
                                //行内数据，当前块数据
                                this.getSub(p.row,result)
                            }
                        }
                    },'详情')
                }
            })
        }
        return row
    }
    /**
     * 获取钻取配置
     * @param queryParaIdArr 钻取数据所需条件，由图表块描述返回
     * @param drillQueryTypeId 获取钻取配置Id
     * @param id 获取钻取数据Id
     * @param id 获取钻取数据Id
     * @param list 存储展示数据
     * @param first 第一次加载
    **/
    async load(queryParaIdArr,drillQueryTypeId,id,queryResultArr,list,first = false){
        let res:any = await this.GetQuerySetting({
            queryTypeId:drillQueryTypeId
        })
        if(first){
            this.result = res.data
            this.tabs = [{name:res.data.name,closable:false}]
            this.activeName = res.data.name
        }else{
            this.subresult = res.data
        }
        //类型为图表加表格
        if(res.data.displayType==3){
            let row = this.renderRow(first?this.result:this.subresult)
            let row2 = res.data.queryResultDto.map((v,index) => {
                return v.columnComment
            });
            let columns = [
                {...res.data,column:row2,loading:true,},
                {...res.data,column:row,chartType:12,loading:true,},
            ]
            if(first){
                this.columns = columns
            }else{
                this.subcolumns = columns
            }
        }else{
            let row = res.data.queryResultDto.map((v,index) => {
            //表格需要key 
                if(res.data.displayType === 1){
                    return {
                        title:v.columnComment,
                        key:'k'+index
                    }
                }else if(res.data.displayType === 2){
                    return v.columnComment
                }
            });
            if(res.data.displayType==1){
                row = this.renderRow(first?this.result:this.subresult)
            }
            let columns = [
                {...res.data,column:row,chartType:res.data.displayType === 1?12:res.data.chartType},
            ]
            if(first){
                this.columns = columns
            }else{
                this.subcolumns = columns
            }
        }
        this.getData(queryParaIdArr,id,queryResultArr,first?this.columns:this.subcolumns,list,first)
        
    }
    //子钻取条件存储
    subqueryParaIdArr:any = []
    /**
     * 获取钻取数据（参数同上）
     * @param columns 列描述
    **/
    async getData(queryParaIdArr,id,queryResultArr,columns,list,first){
        let data =  {
            queryResultArr:queryResultArr,
            queryTypeId:id,
            queryParaIdArr:queryParaIdArr,
            pageSize:10000,
            page:1,
        }
        let res = await this.DrillData(data)
        if(first){
            this.subqueryParaIdArr = res.data.queryParaIdArr
        }
        let vm = this;
        for (let i = 0; i < columns.length; i++) {
            //使用闭包 防止变量污染
            (function (i)  {
                let item = columns[i];
                //生产图表所需数据对象
                let robj:any = vm.renderData(item.chartType,res.data.data.resultData,i,columns)
                list[robj.index] = robj.data
                vm.$set(list,robj.index,robj.data)
                columns[i].loading = false
            })(i);
        }
        console.log(this.subcolumns,this.sublist)
    }

    searchDetail(data:any,index:any){
        console.log(data)
    }
    //存储动态生tabs调取时参数
    subTabData:any = []
    async getSub(row:any,item:any){
        console.log(row,item)
        if(!item.drillQueryTypeId){
            return false
        }
        let rowName;
        if(row instanceof Array){
            item.queryResultArr = row
            rowName = row[0]
        }else{
            rowName = row.k0
            item.queryResultArr = Object.values(row)
        }
        console.log(rowName)
        let names = this.subTabData.map((e:any)=>{return e.name})
        if(!names.includes(rowName)){
            this.subTabData.push({
                name:rowName,
                drillQueryTypeId:item.drillQueryTypeId,
                id:item.id,
                queryResultArr:item.queryResultArr,
            })
            this.tabs.push({name:rowName,closable:true})
        }
        this.activeName = rowName
        this.load(
            this.subqueryParaIdArr,
            item.drillQueryTypeId,
            item.id,
            item.queryResultArr,
            this.sublist,
        )
    }

}
